var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item"},[_c('div',{staticClass:"left"},[_vm._t("left",function(){return [_c('span',[_vm._v(_vm._s(_vm.title))])]})],2),_c('div',[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }